/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: evaluation.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateEvaluationRequest,
  CreateEvaluationResponse,
  GetEvaluationAgentsRequest,
  GetEvaluationAgentsResponse,
  GetEvaluationCountsRequest,
  GetEvaluationCountsResponse,
  GetEvaluationMetadataValuesRequest,
  GetEvaluationMetadataValuesResponse,
  GetEvaluationRequest,
  GetEvaluationResponse,
  ListEvaluationsRequest,
  ListEvaluationsResponse,
  UpdateEvaluationRequest,
  UpdateEvaluationResponse,
} from '../types/evaluation';

export const createEvaluationService = (transport: Transport) => ({
  async createEvaluation(
    request: CreateEvaluationRequest,
    options: RequestOptions = {},
  ): Promise<CreateEvaluationResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.EvaluationService.CreateEvaluation, { organization_id });
    return transport.post<CreateEvaluationResponse>(url, body, options);
  },

  async getEvaluation(
    request: GetEvaluationRequest,
    options: RequestOptions = {},
  ): Promise<GetEvaluationResponse> {
    const { organization_id, evaluation_id, ...params } = request;
    const url = getApiPath(API_METHODS.EvaluationService.GetEvaluation, {
      organization_id,
      evaluation_id,
    });
    return transport.get<GetEvaluationResponse>(url, { params, ...options });
  },

  async updateEvaluation(
    request: UpdateEvaluationRequest,
    options: RequestOptions = {},
  ): Promise<UpdateEvaluationResponse> {
    const { organization_id, evaluation_id, ...body } = request;
    const url = getApiPath(API_METHODS.EvaluationService.UpdateEvaluation, {
      organization_id,
      evaluation_id,
    });
    return transport.post<UpdateEvaluationResponse>(url, body, options);
  },

  async listEvaluations(
    request: ListEvaluationsRequest,
    options: RequestOptions = {},
  ): Promise<ListEvaluationsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.EvaluationService.ListEvaluations, { organization_id });
    return transport.get<ListEvaluationsResponse>(url, { params, ...options });
  },

  async getEvaluationCounts(
    request: GetEvaluationCountsRequest,
    options: RequestOptions = {},
  ): Promise<GetEvaluationCountsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.EvaluationService.GetEvaluationCounts, { organization_id });
    return transport.get<GetEvaluationCountsResponse>(url, { params, ...options });
  },

  async getEvaluationAgents(
    request: GetEvaluationAgentsRequest,
    options: RequestOptions = {},
  ): Promise<GetEvaluationAgentsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.EvaluationService.GetEvaluationAgents, { organization_id });
    return transport.get<GetEvaluationAgentsResponse>(url, { params, ...options });
  },

  async getEvaluationMetadataValues(
    request: GetEvaluationMetadataValuesRequest,
    options: RequestOptions = {},
  ): Promise<GetEvaluationMetadataValuesResponse> {
    const { organization_id, key, ...params } = request;
    const url = getApiPath(API_METHODS.EvaluationService.GetEvaluationMetadataValues, {
      organization_id,
      key,
    });
    return transport.get<GetEvaluationMetadataValuesResponse>(url, { params, ...options });
  },
});

export type EvaluationService = ReturnType<typeof createEvaluationService>;
